(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/embedded-giving/pay/components/stripe/eg.pay.components.stripe', '<div class="eg-flex-col">\n' + '  <div class="eg-paragraph eg-pb1">Credit / Debit Card&nbsp;<span class="eg-error">*</span></div>\n' + '  <div id="card-element" data-tracked-element="donation-page_checkout_stripe-input"></div>\n' + '  <div id="card-errors" class="{{::$ctrl.cardErrorClassName}}" role="alert"></div>\n' + '</div>\n' + '');
}]);
})();